<template>
  <div>
    <Detail_customer_point/>
  </div>
</template>

<script>
import Detail_customer_point from "@/components/adminArin/pos_system/customerpoint/Detail_customer_point";
export default {
  name: "detailcustomerpoint",
  components: {
    Detail_customer_point
  }
}
</script>

<style scoped>

</style>
